import { render } from "./registerFormBody.vue?vue&type=template&id=1940bd41&scoped=true"
import script from "./registerFormBody.vue?vue&type=script&lang=js"
export * from "./registerFormBody.vue?vue&type=script&lang=js"

import "./registerFormBody.vue?vue&type=style&index=0&id=1940bd41&scoped=true&lang=css"
import "./registerFormBody.vue?vue&type=style&index=1&id=1940bd41&lang=css"
script.render = render
script.__scopeId = "data-v-1940bd41"

export default script